import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import api from "@/lib/api";

export const LeaderboardPage = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data || [])); }, []);
  return (
    <div className="space-y-6" data-testid="leaderboard-page">
      <div>
        <h1 className="font-display text-3xl font-bold">Leaderboard</h1>
        <p className="text-[#8a8a8a] text-sm mt-1">Top funded traders this period.</p>
      </div>
      <div className="glass rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] tracking-widest text-[#8a8a8a] uppercase border-b border-[#ff7a00]/15">
              <th className="text-left p-4 w-20">Rank</th>
              <th className="text-left p-4">Trader</th>
              <th className="text-left p-4">Country</th>
              <th className="text-right p-4">Account</th>
              <th className="text-right p-4">P&amp;L</th>
              <th className="text-right p-4">%</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-[#8a8a8a]"><Trophy className="mx-auto text-[#ff7a00] mb-3" size={28} />Leaderboard is forming. Be the first.</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.rank} className="border-b border-[#ff7a00]/5 hover:bg-white/2" data-testid={`leaderboard-row-${r.rank}`}>
                <td className="p-4">
                  <div className={`w-9 h-9 rounded-full flex items-center justify-center font-display font-bold ${
                    r.rank === 1 ? "bg-[#ff7a00] text-[#050505]" :
                    r.rank <= 3 ? "bg-[#ff7a00]/20 text-[#ff7a00] border border-[#ff7a00]/30" :
                    "bg-white/5 text-[#cfcfcf]"
                  }`}>#{r.rank}</div>
                </td>
                <td className="p-4 text-[#f5f5f5] font-semibold">{r.name}</td>
                <td className="p-4 text-[#8a8a8a]">{r.country || "—"}</td>
                <td className="p-4 text-right text-[#cfcfcf]">${r.account_size.toLocaleString()}</td>
                <td className={`p-4 text-right font-semibold ${r.pnl >= 0 ? "text-emerald-400" : "text-red-400"}`}>
                  {r.pnl >= 0 ? "+" : ""}${r.pnl.toLocaleString()}
                </td>
                <td className={`p-4 text-right font-display font-bold ${r.pnl_pct >= 0 ? "text-[#ff7a00]" : "text-red-400"}`}>
                  {r.pnl_pct >= 0 ? "+" : ""}{r.pnl_pct.toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
